import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container text-md-start text-center mb-4 mt-5" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-xl-6 col-md-7 order-md-1 mb-4" }
const _hoisted_4 = { class: "mb-md-5 mb-4 mx-md-0 mx-auto pb-2 lead" }
const _hoisted_5 = {
  class: "col-md-4 offset-xl-1 order-md-2",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "display-1 mb-sm-4 mt-n4 mt-sm-n5" }, "Erro 403", -1)),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.msg || 'Acesso Negado! Você não tem permissão para acessar este conteúdo. Se você acredita que deveria ter acesso, entre em contato com o administrador do sistema.'), 1),
        _createVNode(_component_router_link, {
          to: "/home",
          class: "btn btn-lg btn-primary shadow-primary w-sm-auto w-100"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "bx bx-home-alt me-2 ms-n1 lead",
              "aria-hidden": "true"
            }, null, -1),
            _createTextVNode(" Ir para página Inicial ", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Vue3Lottie, {
          animationData: _ctx.animation,
          background: "transparent",
          speed: 0.5,
          loop: false,
          autoPlay: !_ctx.movimentoReduzido,
          style: {"max-width":"100%","height":"auto"}
        }, null, 8, ["animationData", "autoPlay"])
      ])
    ])
  ]))
}